module.exports = __webpack_public_path__ + "static/media/57a79aa3-9b06-4ba7-a9a4-2b766d826ecf.5cfd714b.woff";